var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoLight = function SvgLogoLight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 333.6",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wordmark"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "513.28 157.13 424.89 157.13 424.89 93.33 402.51 93.33 402.51 243.15 424.89 243.15 424.89 178.09 513.28 178.09 513.28 243.15 535.66 243.15 535.66 93.33 513.28 93.33 513.28 157.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M613.16,154.19c14.66,0,24.96,7.55,29.84,21.87h-60.03c4.23-13.92,15.21-21.87,30.3-21.87M613.28,135.72c-30.36,0-53.28,23.64-53.28,54.94-.61,29.75,23.02,54.37,52.77,54.97.8.02,1.6.01,2.4,0,36.13,0,48.77-24.24,50.37-32.73l.23-1.31h-20.75l-.31.63c-.26.54-7.09,13.72-29.53,13.72-18.47,0-32.19-13.04-33.73-31.84h85.19v-1.14c0-33.7-22.01-57.17-53.51-57.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M738.42,225.94c-19.75,0-33.56-14.52-33.56-35.25s13.81-35.27,33.56-35.27,33.19,14.49,33.19,35.27-13.64,35.25-33.19,35.25M771.18,152.39c-5.17-7.15-16.98-16.67-36.28-16.67-30.53,0-51.83,22.61-51.83,54.97s21.3,54.94,51.83,54.94c14.22.43,27.76-6.1,36.28-17.49v15.01h21.15V87.93h-21.15v64.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M870.63,154.19c14.64,0,24.96,7.55,29.82,21.87h-60.03c4.23-13.92,15.21-21.87,30.33-21.87M870.75,135.72c-30.39,0-53.31,23.64-53.31,54.94-.61,29.75,23.02,54.37,52.77,54.97.8.02,1.6.01,2.4,0,36.13,0,48.77-24.24,50.37-32.73l.23-1.31h-20.75l-.29.63c-.29.54-7.15,13.72-29.56,13.72-18.47,0-32.16-13.04-33.7-31.84h85.33v-1.14c0-33.7-22.01-57.17-53.48-57.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M969.23,153.47v-15.26h-21.18v104.91h21.18v-59.09c0-18.35,9.58-25.5,34.3-25.5h27.33v-21.15h-26.9c-20.95,0-30.47,9.29-34.62,16.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1124.85,190.67c0,20.44-13.52,35.27-32.13,35.27s-32.96-14.49-32.96-35.27,13.64-35.25,33.05-35.25,32.13,14.84,32.13,35.25M1124.5,152.45c-4.14-5.72-14.69-16.72-35.25-16.72-25.44,0-51.2,18.87-51.2,54.94,0,32.36,21.04,54.97,51.2,54.97,13.91.55,27.17-5.95,35.25-17.29v14.89h21.15v-105.02h-21.15v14.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1166.15 141.33 1171.96 141.33 1171.96 154.45 1174.13 154.45 1174.13 141.33 1179.93 141.33 1179.93 139.32 1166.15 139.32 1166.15 141.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1196.66 139.32 1191.65 151.27 1186.65 139.32 1183.25 139.32 1183.25 154.45 1185.31 154.45 1185.31 141.33 1190.85 154.53 1192.34 154.53 1197.83 141.44 1197.83 154.45 1200 154.45 1200 139.32 1196.66 139.32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.88,
    y: 154.81,
    width: 93.86,
    height: 23.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.8,0C74.68,0,0,74.68,0,166.8s74.68,166.8,166.8,166.8,166.8-74.68,166.8-166.8S258.92,0,166.8,0ZM235.71,241.71h-21.97v-46.94h-93.86l-.02-.04v46.98h-21.97V91.89h21.97v46.97l.02-.02h93.86v-46.94h21.97v149.82Z"
  }))))));
};
export default SvgLogoLight;